import { render, staticRenderFns } from "./CLocation.vue?vue&type=template&id=70534aa8&scoped=true&"
import script from "./CLocation.vue?vue&type=script&lang=js&"
export * from "./CLocation.vue?vue&type=script&lang=js&"
import style0 from "./CLocation.vue?vue&type=style&index=0&id=70534aa8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70534aa8",
  null
  
)

export default component.exports